/**
 * The console's single definition of "home": the index redirect, the post-auth
 * fallback, the sign-in return targets and the 404 recovery link. Deliberately
 * a standalone module with no imports so every home site (including `router.tsx`)
 * can reference it without a circular import. `/dashboard` is the designed
 * landing screen (TMMRSL-0005).
 */
export const HOME_PATH = '/dashboard';
